import React from "react";
import Switch from "@ui/Switch";
import t from "../../../i18n";
import { useBreaksBetweenGroups } from "./useBreaksBetweenGroups";
import { computeGroupBreaks } from "../Chart/hooks/useGroupBreaks";

interface P {
  projectId: string;
  groupables: {
    date: number;
    group: string | null;
  }[];
}

function ToggleGroupBreaks({ groupables, projectId }: P) {
  const groupBreaks = React.useMemo(() => computeGroupBreaks(groupables), [groupables]);
  const [breakBetweenGroups, toggleBreakBetweenGroups] = useBreaksBetweenGroups({
    scope: projectId,
  });

  const handleChange = React.useCallback(() => {
    toggleBreakBetweenGroups(s => !s);
  }, [toggleBreakBetweenGroups]);

  return (
    <Switch
      checked={groupBreaks.length === 0 ? false : !breakBetweenGroups}
      onChange={handleChange}
      disabled={groupBreaks.length === 0}
    >
      {t("doNotbreakBetweenGroups.text")}
    </Switch>
  );
}

export default React.memo(ToggleGroupBreaks);
